import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { DEFAULT_AVATAR } from '../../constant';
import useProfile from '../../hooks/useProfile';
import { initData } from '../modal/training-module/post/provider/CreatePostValueProvider';

const PostModal = dynamic(
  () => import('../modal/training-module/post/PostModal')
);

const CreatePostInput = () => {
  const router = useRouter();
  const { gid: groupId } = router.query;

  const [openCreatePostModal, setOpenCreatePostModal] =
    useState<boolean>(false);

  const { data } = useProfile();

  return (
    <>
      <div className="flex flex-1 items-center gap-4">
        <Image
          alt="avatar"
          src={data?.profiles.avatar || DEFAULT_AVATAR}
          width={40}
          height={40}
          className="overflow-hidden rounded-full"
          unoptimized
        />
        <div className="flex-grow">
          {/* use div instead of input cause it will open modal create post no matter what */}
          <div
            onClick={() => setOpenCreatePostModal(true)}
            className="cursor-pointer rounded-lg border border-solid border-[#BFBFBF4D] bg-[#F1F1F1] px-4 py-3"
          >
            <span className="text-base font-semibold leading-[140%] tracking-[-0.3px] text-[#242424]">
              Tạo bài viết...
            </span>
          </div>
        </div>
      </div>
      {openCreatePostModal && (
        <PostModal
          open={openCreatePostModal}
          onClose={() => setOpenCreatePostModal(false)}
          defaultData={{ ...initData, groupId: groupId as string }}
        />
      )}
    </>
  );
};
export default CreatePostInput;
